export class EntityResourceUrls {
    entityName: string;
    entityResourceUrl: string;
    collectionResourceUrl: string;


    constructor(entityName: string, entityResourceUrl: string, collectionResourceUrl: string) {
        this.entityName = entityName;
        this.entityResourceUrl = entityResourceUrl;
        this.collectionResourceUrl = collectionResourceUrl;
    }
}